import React from "react";
import { Label } from "@/components/ui/label";

export const RadioCard = ({ checked, onClick, icon: Icon, label, sublabel, testid }) => (
  <button
    type="button"
    data-testid={testid}
    data-state={checked ? "checked" : "unchecked"}
    onClick={onClick}
    className={`group flex flex-col items-center justify-center gap-2 p-4 border rounded-md cursor-pointer transition-all duration-150 active:scale-[0.98]
      ${
        checked
          ? "border-blue-700 bg-blue-50 ring-1 ring-blue-700"
          : "border-zinc-200 bg-white hover:border-blue-600 hover:bg-blue-50/40"
      }`}
  >
    <Icon className={`w-6 h-6 ${checked ? "text-blue-700" : "text-zinc-500 group-hover:text-blue-700"}`} />
    <div className="text-center">
      <div className={`text-sm font-semibold tracking-wide ${checked ? "text-blue-900" : "text-zinc-800"}`}>
        {label}
      </div>
      {sublabel && (
        <div className="text-[11px] uppercase tracking-wider text-zinc-500 mt-0.5">
          {sublabel}
        </div>
      )}
    </div>
  </button>
);

export const SectionLabel = ({ children, hint }) => (
  <div className="flex items-baseline justify-between mb-3">
    <span className="text-xs font-semibold tracking-[0.14em] uppercase text-zinc-500">
      {children}
    </span>
    {hint && <span className="text-[11px] text-zinc-400 font-mono">{hint}</span>}
  </div>
);

export const FieldLabel = ({ htmlFor, icon: Icon, children }) => (
  <Label
    htmlFor={htmlFor}
    className="flex items-center gap-1.5 text-xs font-semibold tracking-[0.12em] uppercase text-zinc-500 mb-1.5"
  >
    {Icon && <Icon className="w-3.5 h-3.5" />}
    {children}
  </Label>
);
